import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { ConfigService } from '../../generated-api';

type AppState = {
  loading: boolean;
};

const initialState: AppState = {
  loading: false,
};

export const AppStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, configService = inject(ConfigService)) => ({
    setLoading: (loading: boolean) => patchState(store, { loading }),
  }))
);
